import { render, staticRenderFns } from "./OnlineWaTemplates.vue?vue&type=template&id=50554094&"
import script from "./OnlineWaTemplates.vue?vue&type=script&lang=js&"
export * from "./OnlineWaTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports